var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.inModal)?_c('Pane',{attrs:{"title":'添加物资采购记录'}}):_vm._e(),_c('div',{class:{ container: !_vm.inModal }},[_c('PurchaseMaterialsForm',{ref:"form",attrs:{"detailData":_vm.detailData},on:{"submit":_vm.handleSubmit,"close":_vm.handleClose}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }